import React from 'react';
import Select, { components } from 'react-select';
import { TbGridDots } from 'react-icons/tb';
import { HiChevronDown } from 'react-icons/hi';
import Form from 'react-bootstrap/Form';
import { useEffect, useState } from 'react';
import { FaSpinner } from 'react-icons/fa';
import { InvoiceReportService } from '../../services/InvoiceReportService';

const FacilityDropDown = ({ lockboxformik, isSingle = false, width = "250px", name = "facilities", isClient = true, isDisabled = false, isDisableOnchange = false }) => {
    const [isFocusedFacility, setIsFocusedFacility] = useState(false);
    const [facilities, setFacilities] = useState([]);
    const [isLoadingFacilities, setIsLoadingFacilities] = useState(false);

    const invoiceReportService = new InvoiceReportService();
    const { getFacilityDropdown } = invoiceReportService;

    const DropdownIndicator = ({ state, ...props }) => {
        return (
            <components.DropdownIndicator {...props}>
                {isLoadingFacilities ? (
                    <FaSpinner className="spinner" style={{ fontSize: "1.5em", animation: "spin 1s linear infinite" }} />
                ) : lockboxformik.values?.[state]?.length > 1 ? (
                    <TbGridDots style={{ fontSize: "1.5em" }} />
                ) : (
                    <HiChevronDown style={{ fontSize: "1.5em" }} />
                )}
            </components.DropdownIndicator>
        );
    };

    useEffect(() => {
        let apiTimeout = null;

        if (isClient && lockboxformik?.values?.clients?.length === 0) {
            lockboxformik.setFieldValue(name, []);
        }

        setIsLoadingFacilities(true);

        const clientIds = lockboxformik?.values?.clients || [];
        if (clientIds?.length > 0) {
            apiTimeout = setTimeout(() => {
                getFacilityDropdown(clientIds).then((response) => {
                    setIsLoadingFacilities(false);

                    if (response?.status) {
                        const apiResponse = response?.data?.facilities || [];
                        const selectedFacilityIds = apiResponse.flatMap(i => i?.facilities)?.map(ite => ite.value);
                        const filterFacilities = lockboxformik?.values?.[name]?.filter(i => selectedFacilityIds.includes(i));

                        if (isClient && lockboxformik?.values?.clients?.length > 0) {
                            lockboxformik.setFieldValue(name, filterFacilities || []);
                        }

                        setFacilities(
                            apiResponse.map((result) => ({
                                options: result?.facilities,
                                label: result?.client,
                                id: result?.pk
                            }))
                        );
                    }
                });
            }, 600);
        } else {
            setIsLoadingFacilities(false);
        }

        return () => clearTimeout(apiTimeout);
    }, [lockboxformik?.values?.clients]);

    const handleChange = (e) => {
        lockboxformik.setFieldValue(name, !isSingle ? e.map(i => i.value) : [e?.value]);
    };

    const value = !isSingle
        ? facilities?.flatMap(i => i?.options)?.filter(j => lockboxformik?.values?.[name]?.includes(j?.value))
        : facilities[0]?.options?.filter(j => lockboxformik?.values?.[name]?.includes(j?.value));

    return (
        <div style={{ width: `${width}` }}>
            <Form.Group>
                <Select
                    className="basic-single select-search-facility-component"
                    classNamePrefix="select"
                    isDisabled={isLoadingFacilities || isDisabled}
                    isMulti={!isSingle}
                    tabSelectsValue={false}
                    closeMenuOnSelect={isSingle}
                    value={value}
                    name={name}
                    menuPortalTarget={document.body}
                    components={{
                        DropdownIndicator: (props) => <DropdownIndicator {...props} state={name} />
                    }}
                    options={facilities}
                    onFocus={() => setIsFocusedFacility(true)}
                    onBlur={() => setIsFocusedFacility(false)}
                    onChange={isDisableOnchange ? undefined : handleChange}
                    placeholder="Facilities"
                    styles={{
                        container: (styles) => ({
                            ...styles,
                            borderRadius: "9px"
                        }),
                        control: (styles, state) => ({
                            ...styles,
                            backgroundColor: "hsl(204deg 33.33% 97.06%)",
                            borderStyle: "none",
                            boxShadow: "none",
                            borderRadius: "10px",
                            maxHeight: state.isFocused ? "auto" : "30px"
                        }),
                        indicatorSeparator: (styles) => ({
                            ...styles,
                            width: "0px",
                            minHeight: "20px"
                        }),
                        valueContainer: (styles, state) => ({
                            ...styles,
                            maxHeight: isFocusedFacility ? "auto" : "30px"
                        }),
                        placeholder: (styles) => ({
                            ...styles,
                            fontSize: "12px"   // increase placeholder font size
                        }),
                        menuPortal: base => ({ ...base, zIndex: 9999 })
                    }}
                />
                {lockboxformik.errors?.[name] &&
                    <span className='text-danger'>{lockboxformik.errors?.[name]}</span>
                }
            </Form.Group>
        </div>
    );
};

export default React.memo(FacilityDropDown);
